import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MICRO_INGREDIENT_IDS } from '../../../utils/productSuggestions';

const CARD_DOT_CLASSES = [
  't-bg-navy', 't-bg-navy/70', 't-bg-navy/50', 't-bg-navy/30',
  't-bg-navy', 't-bg-navy/70', 't-bg-navy/50', 't-bg-navy/30',
];

const IngredientCard = ({
  item,
  index,
  ingredientData,
  defaultOpen = false,
  showScientificName = false,
  onToggle,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const isMicro = MICRO_INGREDIENT_IDS.includes(item?.ingredient_id);
  const unit = isMicro ? 'µg' : 'mg';
  const dose = isMicro ? Math.round(parseFloat(item?.daily_dose) * 1000) : item?.daily_dose;
  const nrv = parseFloat(ingredientData?.eu_nrv) <= 0 ? '*' : `${item.per_eu_nrv}%`;
  const dotClass = CARD_DOT_CLASSES[index % CARD_DOT_CLASSES.length];

  const handleToggle = () => {
    setIsOpen((isCurrentlyOpen) => !isCurrentlyOpen);
    onToggle?.();
  };

  return (
    <div
      className={`t-border t-rounded-lg t-mb-1.5 t-bg-white t-overflow-hidden t-cursor-pointer t-transition-colors ${
        isOpen ? 't-border-navy/30' : 't-border-g200 hover:t-border-navy/30'
      }`}
      onClick={handleToggle}
    >
      <div className="t-flex t-items-center t-gap-3 t-px-3 t-py-2.5">
        <div className={`t-w-2.5 t-h-2.5 t-rounded-full t-flex-shrink-0 ${dotClass}`} />
        <div className="t-flex-1 t-min-w-0">
          <p className="!t-m-0 t-text-[13px] t-font-bold t-text-navy t-leading-snug">
            {item.ingredient}
          </p>
          {showScientificName && item.scientific_name && (
            <p className="!t-m-0 t-text-[11px] t-text-navy/70 t-leading-snug">
              {item.scientific_name}
            </p>
          )}
        </div>
        <div className="t-flex t-items-center t-gap-2 t-flex-shrink-0">
          <span className="t-text-xs t-font-semibold t-text-navy t-min-w-[44px] t-text-right">
            {dose} {unit}
          </span>
          <span className="t-text-xs t-text-navy/60 t-min-w-[28px] t-text-right">{nrv}</span>
          <span className="t-text-[10px] t-text-navy/50 t-w-2.5">{isOpen ? '▲' : '▼'}</span>
        </div>
      </div>
      {isOpen && item.description && (
        <div className="t-border-t t-border-g200 t-px-3 t-pb-3">
          <div className="t-bg-navy/5 t-rounded-lg t-px-3 t-py-2 t-mt-2">
            <p className="!t-m-0 !t-mb-1 t-text-[10px] t-font-bold t-text-navy t-uppercase t-tracking-wide t-text-center">
              {item.manually_added ? t('IngredientCard_YouAddedThis') : t('IngredientCard_WhyWeAddedThis')}
            </p>
            <p className="!t-m-0 t-text-[12px] t-text-navy t-leading-relaxed">{item.description}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default IngredientCard;
